module.exports = __webpack_public_path__ + "static/media/QAP2BEL_open.b141b020.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/callouts/QAP2BEL_open.png
// module id = 1026
// module chunks = 0